/* Groe — product page behaviour
   =======================================================================
   Loaded only on the product template, after groe.js.

   NO MONEY MATHS HAPPENS HERE. Every figure this file writes — tile price,
   struck price, button label, instalment — was formatted by Liquid's `money`
   filter and parked on a data attribute, because money formatting differs per
   shop and per currency and a second implementation in JavaScript is a second
   thing to get wrong. This file only chooses which prepared string to show.

   Same lifecycle contract as groe.js: an init(root) pass, idempotent, re-run on
   shopify:section:load so the Theme Editor cannot leave a dead control behind.
   ===================================================================== */
(function () {
  'use strict';

  var observers = [];

  function claim(el, key) {
    if (!el || el.dataset[key] === 'true') return false;
    el.dataset[key] = 'true';
    return true;
  }

  /* ── gallery ──────────────────────────────────────────────── */
  function initGallery(root) {
    var fig = root.querySelector('.pg');
    if (!claim(fig, 'groePg')) return;
    var stage = fig.querySelector('#pgMain');
    var thumbs = fig.querySelectorAll('.pg-thumb');
    if (!stage || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
          t.setAttribute('aria-selected', String(t === thumb));
        });
        stage.src = thumb.dataset.src;
        stage.alt = thumb.dataset.alt || '';
      });
    });
  }

  /* ── purchase options ─────────────────────────────────────── */
  function initChoose(root) {
    var choose = root.querySelector('.choose');
    if (!claim(choose, 'groeChoose')) return;

    var opts = choose.querySelectorAll('.opt');
    /* Subscription plan tiles only: the one-time pack tiles share the look
       (.tier) but are plain radios, handled through `qty`. */
    var tiers = choose.querySelectorAll('.tier:not(.tier-pack)');
    var subCta = choose.querySelector('[data-sub-cta]');
    var onceCta = choose.querySelector('[data-once-cta]');
    var subWas = choose.querySelector('[data-sub-was]');
    var subNow = choose.querySelector('[data-sub-now]');
    var onceNow = choose.querySelector('[data-once-now]');
    var subVariant = choose.querySelector('[data-sub-variant]');
    var shipSelect = choose.querySelector('[data-ship-select]');
    var shipInput = choose.querySelector('[data-ship-input]');
    var subPlan = choose.querySelector('[data-sub-plan]');
    var qty = choose.querySelector('[data-once-qty]');
    var instalment = choose.querySelector('[data-instalment-output]');
    var perkList = choose.querySelector('.perks');
    var fabCta = document.querySelector('[data-fab-cta]');
    var fabPlan = document.querySelector('[data-fab-plan]');
    var onceLabelEl = document.querySelector('[data-once-label]');
    var onceForm = onceCta ? onceCta.form : null;
    var wlSub = choose.querySelector('[data-wl="sub"]');
    var wlOnce = choose.querySelector('[data-wl="once"]');
    var wlInput = choose.querySelector('[data-wl] input');
    var wlForm = wlInput ? wlInput.form : null;
    var wlTags = wlForm ? wlForm.querySelector('[data-wl-tags]') : null;

    var mode = choose.querySelector('.opt[data-opt="sub"]') ? 'sub' : 'once';

    /* Only the open card's email box is enabled: both boxes post to the same
       waitlist form, and a disabled field is neither submitted nor validated. */
    function setWaitlist(cta, wl, soldOut, active) {
      if (!cta || !wl) return;
      cta.hidden = soldOut;
      wl.hidden = !soldOut;
      var input = wl.querySelector('input');
      if (input) input.disabled = !(soldOut && active);
    }

    function picked() {
      return choose.querySelector('.tier.is-picked') || tiers[0] || null;
    }

    /* The perk list belongs to the plan, so it is rebuilt rather than patched:
       plans do not all carry the same number of lines. `caveat` marks the one
       line that is a CHARGE rather than a benefit — a shipping fee wearing a
       blue tick would be the list selling its own small print — and it is
       matched on the plan's own caveat field, not on the wording, so rewording
       the line cannot silently turn it back into a perk. */
    function renderPerks(tier) {
      if (!perkList) return;
      var raw = (tier && tier.dataset.perks) || '';
      var caveat = ((tier && tier.dataset.caveat) || '').trim();
      var lines = raw.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);

      var tick = perkList.dataset.checkIcon || '';
      var warn = perkList.dataset.caveatIcon || tick;

      perkList.replaceChildren.apply(perkList, lines.map(function (text) {
        var li = document.createElement('li');
        var isCaveat = Boolean(caveat) && plain(text) === plain(caveat);
        li.classList.toggle('is-caveat', isCaveat);
        var img = document.createElement('img');
        img.src = isCaveat ? warn : tick;
        img.alt = '';
        img.width = 16;
        img.height = 16;
        li.append(img, perkText(text));
        return li;
      }));
    }

    /* `**words**` in a perk line renders bold, so the client can pick which
       words to stress from the Theme Editor. The line is one <span> because
       `.perks li` is a flex row: loose <strong>s would each become a flex item
       and stop wrapping as a sentence. Built with text nodes, never innerHTML. */
    function plain(text) {
      return text.replace(/\*\*/g, '').trim();
    }

    function perkText(text) {
      var span = document.createElement('span');
      text.split('**').forEach(function (part, i) {
        if (!part) return;
        if (i % 2) {
          var b = document.createElement('strong');
          b.textContent = part;
          span.append(b);
        } else {
          span.append(document.createTextNode(part));
        }
      });
      return span;
    }

    function render() {
      opts.forEach(function (o) { o.classList.toggle('is-open', o.dataset.opt === mode); });

      var tier = picked();
      if (tier) {
        tiers.forEach(function (t) {
          var on = t === tier;
          t.classList.toggle('is-picked', on);
          t.setAttribute('aria-checked', String(on));
        });
        if (subVariant) subVariant.value = tier.dataset.variant || '';
        if (shipSelect) fillShip(tier);
        var planId = (shipSelect && shipSelect.value) || tier.dataset.sellingPlan || '';
        /* A real selling plan makes the order a subscription; the interval
           property is only sent when there is none to fall back on. */
        if (subPlan) { subPlan.value = planId; subPlan.disabled = !planId; }
        var shipText = shipSelect && shipSelect.selectedOptions[0] ? shipSelect.selectedOptions[0].text : (tier.dataset.ship || '');
        if (shipInput) { shipInput.value = shipText; shipInput.disabled = Boolean(planId); }
        if (subWas) {
          var was = tier.dataset.was || '';
          subWas.textContent = was === tier.dataset.price ? '' : was;
        }
        if (subNow) subNow.textContent = tier.dataset.price || '';
        if (subCta) subCta.textContent = (subCta.dataset.label || '') + ' · ' + (tier.dataset.price || '');
        renderPerks(tier);
      }

      /* The one-time quantity is a group of pack tiles (radios); the old
         dropdown is still read if a template brings it back. */
      var qtyOption = !qty ? null
        : qty.tagName === 'SELECT' ? qty.options[qty.selectedIndex]
        : qty.querySelector('input:checked');
      if (qtyOption) {
        if (onceNow) onceNow.textContent = qtyOption.dataset.total || '';
        if (onceCta) onceCta.textContent = (onceCta.dataset.label || '') + ' · ' + (qtyOption.dataset.total || '');
      }

      if (instalment) {
        var live = mode === 'sub' && tier ? tier.dataset.instalment
                                          : (qtyOption ? qtyOption.dataset.instalment : '');
        instalment.textContent = live || '';
      }

      /* The floating bar is not a second source of truth — it is written from
         the same state, so it can never disagree with the card above it. */
      var subOut = Boolean(tier) && tier.dataset.available === 'false';
      var onceOut = Boolean(onceForm) && onceForm.dataset.onceAvailable === 'false';
      setWaitlist(subCta, wlSub, subOut, mode === 'sub');
      setWaitlist(onceCta, wlOnce, onceOut, mode === 'once');
      if (wlTags) {
        var planName = mode === 'sub' && tier ? tier.dataset.planLabel : (onceForm ? onceForm.dataset.onceName : '');
        wlTags.value = 'waitlist, Waitlist: ' + (planName || 'Unknown plan');
      }

      if (fabCta && subCta && onceCta) {
        var activeOut = mode === 'sub' ? subOut : onceOut;
        var activeWl = mode === 'sub' ? wlSub : wlOnce;
        fabCta.textContent = activeOut && activeWl
          ? activeWl.querySelector('button').textContent
          : (mode === 'sub' ? subCta.textContent : onceCta.textContent);
      }
      if (fabPlan) {
        fabPlan.textContent = mode === 'sub' && tier
          ? (subCta ? subCta.dataset.label : '') + ' · ' + (tier.dataset.planLabel || '')
          : (onceLabelEl ? onceLabelEl.dataset.onceLabel : '');
      }
    }

    /* Opening "One-time purchase" collapses the tall subscription card above
       it, so the card the shopper just picked jumps up out of view. Whenever
       "Choose your plan" has ended up above the sticky header, bring it back
       (client request, desktop and mobile). The scroll-padding on <html>
       already allows for the header. */
    function keepChoiceInView() {
      var heading = choose.querySelector('.choose-h') || choose;
      var pad = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      if (heading.getBoundingClientRect().top < pad) {
        heading.scrollIntoView({ block: 'start' });
      }
    }

    choose.querySelectorAll('input[name="buymode"]').forEach(function (radio) {
      radio.addEventListener('change', function () { mode = radio.value; render(); keepChoiceInView(); });
    });
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (t) { t.classList.toggle('is-picked', t === tier); });
        render();
      });
    });
    /* Every interval this plan can ship on, the plan itself unchanged: the
       customer picks a bottle count and then how often it arrives. Falls back to
       the tile's own interval when the app exposes no plans for it. */
    var shipTouched = false;
    function fillShip(tier) {
      var plans = [];
      try { plans = JSON.parse(tier.dataset.plans || '[]'); } catch (e) {}
      if (!plans.length) plans = [{ id: tier.dataset.sellingPlan || '', label: tier.dataset.ship || '' }];
      /* The app hands them back in the order the bars were created, so a bar
         added later lands last ("1, 3, 6, 2 months"). Shortest first instead. */
      plans.sort(function (a, b) { return (parseFloat(a.label) || 0) - (parseFloat(b.label) || 0); });
      /* Until the customer picks a rhythm themselves, each plan opens on its own
         (1 bottle → 1 month), so switching plans does not leave "1 bottle every
         6 months" sitting there. After that their choice is theirs to keep. */
      var current = shipSelect.value;
      var keep = shipTouched && plans.some(function (p) { return String(p.id) === current; });
      var wanted = keep ? current : String(tier.dataset.sellingPlan || plans[0].id);
      shipSelect.replaceChildren.apply(shipSelect, plans.map(function (p) {
        var o = new Option(p.label, p.id);
        o.selected = String(p.id) === wanted;
        return o;
      }));
    }

    if (shipSelect) {
      shipSelect.addEventListener('change', function () { shipTouched = true; render(); });
    }
    if (qty) qty.addEventListener('change', render);

    /* The floating bar appears once the buy column has scrolled PAST, not
       merely whenever it is off screen: a bare !isIntersecting shows the bar
       over the gallery at first paint, while the column is still below the
       fold. */
    var fab = document.getElementById('fab');
    var buy = document.querySelector('.pdp-buy');
    if (fab && buy) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        fab.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
      io.observe(buy);
      observers.push(io);
    }

    /* Shopify reloads the page after a customer form posts, and every customer
       form on the page (the footer newsletter too) reports the same success, so
       the thank-you only shows when this form was the one sent. */
    if (wlForm) {
      wlForm.addEventListener('submit', function () {
        try { sessionStorage.setItem('groeWaitlist', '1'); } catch (e) {}
      });
      var posted = /[?&]customer_posted=true/.test(window.location.search);
      var flagged = false;
      try {
        flagged = sessionStorage.getItem('groeWaitlist') === '1';
        sessionStorage.removeItem('groeWaitlist');
      } catch (e) {}
      if (posted && (flagged || window.location.hash === '#' + wlForm.id)) {
        choose.querySelectorAll('[data-wl-done]').forEach(function (el) { el.hidden = false; });
      }
    }

    render();
  }

  /* ── review filters ───────────────────────────────────────── */
  function initReviews(root) {
    var rev = root.querySelector('.rev');
    if (!claim(rev, 'groeRev')) return;

    var items = rev.querySelectorAll('.rev-item');
    var search = rev.querySelector('input[type="search"]');
    var chips = rev.querySelectorAll('.rev-chip');
    if (!items.length) return;

    /* Three filters that AND together: free text, keyword chips, star chips.
       Within a group the chips OR, which is what a reader expects from
       "show me 4 or 5 stars". */
    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var kws = [], stars = [];
      chips.forEach(function (c) {
        if (c.getAttribute('aria-pressed') !== 'true') return;
        if (c.dataset.kw) kws.push(c.dataset.kw);
        if (c.dataset.stars) stars.push(c.dataset.stars);
      });

      var shown = 0;
      items.forEach(function (item) {
        var text = item.textContent.toLowerCase();
        var itemKws = (item.dataset.kw || '').toLowerCase().split(/\s+/);
        var okText = !q || text.indexOf(q) !== -1;
        var okKw = !kws.length || kws.some(function (k) { return itemKws.indexOf(k) !== -1; });
        var okStars = !stars.length || stars.indexOf(item.dataset.stars) !== -1;
        var visible = okText && okKw && okStars;
        item.hidden = !visible;
        if (visible) shown++;
      });

      var count = rev.querySelector('[data-rev-count]');
      if (count) {
        var word = count.dataset.word || 'reviews';
        count.textContent = shown === items.length
          ? 'Showing all ' + items.length + ' ' + word
          : 'Showing ' + shown + ' of ' + items.length + ' ' + word;
      }
    }

    if (search) search.addEventListener('input', apply);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var on = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', String(!on));
        apply();
      });
    });
  }

  /* ── formula panel: lock the photo to the copy column ─────── */
  /* The designer's rule: the photo is as tall as the copy column in its DEFAULT
     state — first system open, the other two closed — and it does NOT grow when
     a reader opens the others. A fixed aspect-ratio cannot express that: the
     page runs fluid past 1440, so the copy column's height changes with width.
     Measured, then re-measured on resize only. */
  function initFormulaPhoto(root) {
    var panel = root.querySelector('.frm-panel');
    if (!claim(panel, 'groeFrm')) return;
    var photo = panel.querySelector('.frm-photo');
    var copy = panel.querySelector('.frm-copy');
    if (!photo || !copy) return;

    var lock = function () {
      photo.style.height = '';
      var open = panel.querySelectorAll('.frm-row details[open]');
      /* Measure the default state: momentarily close everything but the first. */
      var reopened = [];
      open.forEach(function (d, i) {
        if (i > 0) { d.open = false; reopened.push(d); }
      });
      photo.style.height = copy.offsetHeight + 'px';
      reopened.forEach(function (d) { d.open = true; });
    };

    lock();
    addEventListener('resize', lock);
  }

  /* ── dispatch ─────────────────────────────────────────────── */
  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    observers.forEach(function (io) { io.disconnect(); });
    observers = [];
    initGallery(scope);
    initChoose(scope);
    initReviews(scope);
    initFormulaPhoto(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
